import React from 'react';
import { OverlapRow, formatINR, parseINR } from './overlap.constants';
import styles from './OverlapTooltipContent.module.scss';

interface Props {
    row: OverlapRow;
}

function OverlapTooltipContent({ row }: Props) {
    // Keyed off the row's DISPLAYED total (totalRevenue), matching the Total and Net cells —
    // circularTotal is max(rev, exp) upstream, which for a party we buy more from than we sell to
    // showed a "Total" (and Net) larger than the row itself. circularValue = min(rev, exp) ≤ revenue,
    // so the % here is always ≤ 100.
    const { totalRevenue, circularValue } = row;

    const totalNum = parseINR(totalRevenue);
    const circularNum = parseINR(circularValue);
    const circularPctNum = totalRevenue && circularValue && totalNum ? (circularNum / totalNum) * 100 : NaN;
    const netPct = !isNaN(circularPctNum) ? `${(100 - circularPctNum).toFixed(1)}%` : null;

    const netValue = totalRevenue && circularValue ? formatINR(totalNum - circularNum) : '-';

    return (
        <div className={styles.Container}>
            <p className={styles.Title}>Circular Transaction Detected</p>

            <div className={styles.Rows}>
                <div className={styles.Row}>
                    <div className={styles.Labels}>
                        <span className={styles.Label}>Total</span>
                        {circularValue && (
                            <span className={styles.Label}>Circular{!isNaN(circularPctNum) ? ` (${circularPctNum.toFixed(1)}%)` : ''}</span>
                        )}
                    </div>
                    <div className={styles.Values}>
                        <span className={styles.ValueDefault}>{totalRevenue || '-'}</span>
                        {circularValue && <span className={styles.ValueRed}>{circularValue}</span>}
                    </div>
                </div>

                <div className={styles.Divider} />

                <div className={styles.Row}>
                    <span className={styles.Label}>Net{netPct != null ? ` (${netPct})` : ''}</span>
                    <span className={styles.ValueBold}>{netValue}</span>
                </div>
            </div>
        </div>
    );
}

export default OverlapTooltipContent;
